import { render, staticRenderFns } from "./AddCorporateProfile.vue?vue&type=template&id=2d65cd18&scoped=true&"
import script from "./AddCorporateProfile.vue?vue&type=script&lang=js&"
export * from "./AddCorporateProfile.vue?vue&type=script&lang=js&"
import style0 from "./AddCorporateProfile.vue?vue&type=style&index=0&id=2d65cd18&lang=scss&scoped=true&"
import style1 from "./AddCorporateProfile.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d65cd18",
  null
  
)

export default component.exports